import React, { FC } from 'react'
import styled from 'styled-components'
import { Icon } from 'ui/icon'

import { getProjectName } from '../../../lib/get-project-name'

export type Props = {
  text: string
  groupingCities: Array<{
    name: string
  }>
  showLocationAs: string | null
  longNameDealers: string
}

export const Dealer: FC<Props> = ({ text, groupingCities, showLocationAs, longNameDealers }) => {
  if (getProjectName() === 'avito') longNameDealers = text
  return (
    <Wrapper>
      <Inner>
        <Icon name={getProjectName() === 'generic_v2' ? 'location-generic-v2' : 'location'} size={0.75} />
        <WrapperText>
          {showLocationAs !== 'cities' ? (
            longNameDealers ? (
              <Text>{longNameDealers}</Text>
            ) : (
              <Text>{text}</Text>
            )
          ) : (
            groupingCities.map((item, index) => {
              return (
                <Text>
                  {item.name}
                  {groupingCities.length - 1 > index ? ',' : null}
                </Text>
              )
            })
          )}
        </WrapperText>
      </Inner>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: relative;
  vertical-align: baseline;
  line-height: 1;
`

const Inner = styled.div`
  display: flex;
  line-height: 1.5;
  color: ${({ theme }) => theme.palette.grey[500]};
`

const Text = styled.span`
  margin-right: ${({ theme }) => theme.spacing[1]};
  ${({ theme }) => theme.textStyles.p3};
  color: ${({ theme }) => {
    if (getProjectName() === 'tank') return theme.palette.white
    return theme.palette.grey[700]
  }};
  font-size: ${() => {
    if (getProjectName() === 'tank') return '1.2rem'
    return
  }};

  ${({}) =>
    getProjectName() === 'generic_v2' &&
    `
      font-size: 12px;
      color: #828282;

      @media (min-width: 768px) {
        font-size: 14px;
      }
  `}
`

const WrapperText = styled.div`
  margin-left: 5px;
`
